import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import Prism from 'prismjs';
export var decorationNode = function decorationNode(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    node = _ref2[0],
    path = _ref2[1];
  if (node.type !== 'code_block') return [];
  var languageType = node.data.syntax;
  if (languageType === 'none') return [];
  var grammer = Prism.languages[languageType];
  var codeLines = node.children;
  if (!grammer) {
    return [];
  }
  var blockText = codeLines.map(function (codeLine) {
    return codeLine.children[0].text;
  }).join('\n');
  var tokens = Prism.tokenize(blockText, grammer);
  var decorations = [];
  var textLine = 0;
  var offset = 0;
  var _iterator = _createForOfIteratorHelper(tokens),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var token = _step.value;
      if (typeof token === 'string' && token.indexOf('\n') >= 0) {
        //the varialble enterNum is the num of \n in the token
        // get the number of \n buy split the token by '\n'
        var newlineTokens = token.split('\n');
        var enterNum = newlineTokens.length - 1;
        // get the next code_line which the content of is is not ' ' or null;
        textLine += enterNum;
        // get the initial offset of the code_line
        offset = newlineTokens.pop().length;
        continue;
      }
      if (typeof token === 'string') {
        var textPath = path.slice();
        textPath.push(textLine, 0);
        var decoration = {
          anchor: {
            path: textPath,
            offset: offset
          },
          focus: {
            path: textPath,
            offset: offset + token.length
          },
          type: 'text'
        };
        decorations.push(decoration);
        offset += token.length;
      } else if (typeof token.content === 'string') {
        var _textPath = path.slice();
        _textPath.push(textLine, 0);
        var _decoration = {
          anchor: {
            path: _textPath,
            offset: offset
          },
          focus: {
            path: _textPath,
            offset: offset + token.content.length
          },
          decoration: true,
          type: token.type
        };
        decorations.push(_decoration);
        offset += token.content.length;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return decorations;
};